<template>
  <div class="mb-24 laptop:mb-150px">
    <div
      class="container mx-auto h-auto laptop:h-almostscreen flex-col flex md:justify-center laptop:min-700 fullhd:min-900 min-h-0">
      <div class="z-20 p-1 px-5 lg:px-0 fullhd:ml-0 md:p-5 ">
        <MARSHeading><div v-html="$t('editor.hero')" /></MARSHeading>
        <!--        <h1 class="fullhd:w-full laptop:w-4/5 w-full fullhd:text-10xl text-35px lg:text-7xl md:text-52xl lg:w-full md:font-semibold laptop:text-6xl">-->
        <!--          Pochi passaggi per <br/>mostrare i tuoi prodotti <br/> come vorresti vederli tu.-->
        <!--        </h1>-->
        <ActionButton bg="orange" :href="panelLinks.registerUrl.value" margin-top="mt-12" :value="$t('home.free-trial')" />
        <div class="w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-20">
          <img loading="lazy" class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
        </div>
      </div>
      <div class="w-full laptop:absolute laptop:right-0 laptop:w-3/5 flex content-end justify-end">
        <div>
          <img loading="lazy" class="hidden xl:block lg:max-700 fullhd:max-900" src="~/assets/img/editor-hero-desktop.webp"
               style="height:auto !important;">
        </div>
        <img loading="lazy" class="block  xl:hidden" src="~/assets/img/editor-hero.webp"
             style="width:auto !important;align-self: flex-start;">
      </div>
    </div>
    <div class="container mx-auto flex flex-col laptop:flex-row pt-10 md:pt-16">
      <div class="laptop:w-6/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-5/6">
        <MARSTitle><div v-html="$t('editor.claim')" /></MARSTitle>
        <!--        <h2 class="text-standard laptop:text-55xl font-bold md:mb-8 mb-12 md:w-3/5 fullhd:w-9/12 laptop:w-full md:text-4xl md:leading-normal laptop:leading-tight">-->

        <!--        </h2>-->
        <p class="text-standard laptop:text-slg md:text-base" v-html="$t('editor.claim-text')" />
        <ActionButton bg="orange" :href="panelLinks.registerUrl.value" margin-top="mt-5" :value="$t('home.free-trial')" />
      </div>
    </div>
    <div class="container mx-auto flex flex-col laptop:flex-row py-12 laptop:mt-150px">
      <div class="order-first laptop:order-first w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8">
        <img loading="lazy" alt="Come funziona?" class="w-full h-full" src="~/assets/img/editor-1.webp">
      </div>
      <div
        class="order-last laptop:order-last w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 md:p-0 md:px-8 flex-col laptop:justify-around">
        <div>
          <SubTitle><div v-html="$t('editor.step-1')" /></SubTitle>
          <p class="text-standard text-lg laptop:text-slg mt-4" v-html="$t('editor.step-1-text')" />
          <!-- <img loading="lazy" :src="step1 ? require('~/assets/img/btn-accordion-open.svg') : require('~/assets/img/btn-collapse.svg')"
               alt="Apri dettagli"
               class="mt-8 pointer"
               @click="toggleStep(1)"/> -->
        </div>
      </div>
    </div>
    <div :class="{'max-h-0': step1, 'max-h-300': !step1}"
         class="bg-darkgray overflow-hidden transition-max-height duration-500 ease-in-out my-12">
      <div class="container mx-auto flex flex-col laptop:flex-row py-12">
        <div class="w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8 flex-col">
          <div class="laptop:ml-24">
            <p class="text-white" v-html="$t('editor.step-1-text-1')" />
          </div>
        </div>
        <div class="w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 lg:py-0 md:px-8 flex-col">
          <div class="laptop:mr-24">
            <p class="text-white" v-html="$t('editor.step-1-text-2')" />
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto flex flex-col laptop:flex-row  mt-10">
      <div
        class="order-last laptop:order-first w-full flex laptop:w-5/12 laptop:ml-24 p-5 flex-col laptop:justify-around md:px-8">
        <div class>
          <SubTitle><div v-html="$t('editor.step-2')" /></SubTitle>
          <p class="text-standard text-lg laptop:text-slg mt-4" v-html="$t('editor.step-2-text')" />
          <!-- <img loading="lazy" :src="step2 ? require('~/assets/img/btn-accordion-open.svg') : require('~/assets/img/btn-collapse.svg')"
               alt="Apri dettagli"
               class="mt-8 pointer"
               @click="toggleStep(2)"/> -->
        </div>
      </div>
      <div class="order-first laptop:order-last w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8">
        <img loading="lazy" alt="Come funziona?" class="w-full h-full" src="~/assets/img/editor-2.webp">
      </div>
    </div>
    <div :class="{'max-h-0': step2, 'max-h-300': !step2}"
         class="bg-darkgray overflow-hidden transition-max-height duration-500 ease-in-out my-12">
      <div class="container mx-auto flex flex-col laptop:flex-row py-12">
        <div class="w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8 flex-col">
          <div class="laptop:ml-24">
            <p class="text-white" v-html="$t('editor.step-2-text-1')" />
          </div>
        </div>
        <div class="w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 lg:py-0 md:px-8 flex-col">
          <div class="laptop:mr-24">
            <p class="text-white" v-html="$t('editor.step-2-text-2')" />
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto flex flex-col laptop:flex-row ">
      <div class="order-first laptop:order-first w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8">
        <img loading="lazy" alt="Come funziona?" class="w-full h-full" src="~/assets/img/editor-3.webp">
      </div>
      <div
        class="order-last laptop:order-last w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 md:p-0 md:px-8 flex-col laptop:justify-around">
        <div>
          <SubTitle><div v-html="$t('editor.step-3')" /></SubTitle>
          <p class="text-standard text-lg laptop:text-slg mt-4" v-html="$t('editor.step-3-text')" />
          <!-- <img loading="lazy" :src="step3 ? require('~/assets/img/btn-accordion-open.svg') : require('~/assets/img/btn-collapse.svg')"
               alt="Apri dettagli"
               class="mt-8 pointer"
               @click="toggleStep(3)"/> -->
        </div>
      </div>
    </div>
    <div
      class="w-full bg-right bg-cover laptop:my-150px"
    >
      <div class="container h-full mx-auto">
        <div class="flex flex-col justify-around h-full w-full laptop:w-6/12 laptop:ml-24 p-3 md:px-8 my-12">
          <div>
            <h2 class="text-standard lg:text-25xl " v-html="$t('how.more-info')" />
            <ActionButton :href="$t('links.guide')" :value="$t('how.guide')" bg="highlight" fg="white" />
          </div>
        </div>
      </div>
    </div>
    <div :class="{'max-h-0': step3, 'max-h-300': !step3}"
         class="bg-darkgray overflow-hidden transition-max-height duration-500 ease-in-out my-12">
      <div class="container mx-auto flex flex-col laptop:flex-row py-12">
        <div class="w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8 flex-col">
          <div class="laptop:ml-24">
            <p class="text-white" v-html="$t('editor.step-3-text-1')" />
          </div>
        </div>
        <div class="w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 lg:py-0 md:px-8 flex-col">
          <div class="laptop:mr-24">
            <p class="text-white" v-html="$t('editor.step-3-text-2')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { usePanelLinks } from '~/composables/PanelLinks';

  const panelLinks = usePanelLinks()
  const step1 = true
  const step2 = true
  const step3 = true
  const step4 = true
</script>

<style scoped></style>
